import script from "./UserRoleCell.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserRoleCell.vue?vue&type=script&setup=true&lang=ts"

import "./UserRoleCell.vue?vue&type=style&index=0&id=19d613d5&scoped=true&lang=scss"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19d613d5"]])

export default __exports__